import { useEffect, useState } from 'react';
import { api } from '../api/client.js';

// Moje databáze (JR/JCH): souhrn podle zdroje a seznam kontaktů makléře.
const SOURCES = {
  sphere_10: 'Sféra vlivu',
  cold_call_54: 'Cold call',
  door_knocking_11: 'Door knocking',
  referral: 'Doporučení',
  social: 'Sociální sítě',
  online_leads: 'Online leady',
  networking: 'Networking',
  other: 'Jiné',
};

export default function Kontakty() {
  const [summary, setSummary] = useState([]);
  const [contacts, setContacts] = useState([]);
  const [q, setQ] = useState('');
  const [error, setError] = useState('');

  const load = async () => {
    try {
      const [s, c] = await Promise.all([
        api.get('/core/contacts/summary'),
        api.get('/core/contacts', { params: q ? { q } : {} }),
      ]);
      setSummary(s.data.data);
      setContacts(c.data.data);
      setError('');
    } catch (err) {
      setError(err.response?.data?.error || 'Kontakty se nepodařilo načíst.');
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const remove = async (id) => {
    if (!window.confirm('Smazat kontakt?')) return;
    await api.delete(`/core/contacts/${id}`);
    load();
  };

  return (
    <section className="page">
      <h1>Databáze kontaktů</h1>
      {error && <p role="alert">{error}</p>}
      <table>
        <thead>
          <tr><th>Zdroj</th><th>Kontaktů</th><th>Osloveno</th></tr>
        </thead>
        <tbody>
          {summary.map((r) => (
            <tr key={r.source}>
              <td>{SOURCES[r.source] || r.source}</td>
              <td>{r.contacts}</td>
              <td>{r.reached}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <form onSubmit={(e) => { e.preventDefault(); load(); }}>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Hledat jméno, telefon…" />
        <button type="submit">Hledat</button>
      </form>
      <table>
        <thead>
          <tr><th>Jméno</th><th>Telefon</th><th>Zdroj</th><th>Makléř</th><th /></tr>
        </thead>
        <tbody>
          {contacts.map((c) => (
            <tr key={c.id}>
              <td>{c.name || '—'}</td>
              <td>{c.phone}</td>
              <td>{SOURCES[c.source] || c.source}</td>
              <td>{c.makler_id}</td>
              <td><button type="button" onClick={() => remove(c.id)}>Smazat</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
